import { API_ENDPOINTS } from './apiEndpoints';

export const API_CONFIG = {
  // Environment
  ENV: process.env.REACT_APP_ENV || process.env.NODE_ENV || 'development',
  
  // Base URLs for different services
  AUTH_BASE_URL: process.env.REACT_APP_AUTH_BASE_URL || 'https://0j71xq8ru3.execute-api.us-east-1.amazonaws.com/dev',
  RESUME_BASE_URL: process.env.REACT_APP_RESUME_BASE_URL || 'https://0j71xq8ru3.execute-api.us-east-1.amazonaws.com/dev/api',
  BASE_URL: process.env.REACT_APP_API_BASE_URL || 'https://0j71xq8ru3.execute-api.us-east-1.amazonaws.com/dev/api',
  
  // API Configuration
  TIMEOUT: parseInt(process.env.REACT_APP_API_TIMEOUT || '30000'),
  DEBUG: process.env.REACT_APP_DEBUG_API === 'true' || process.env.NODE_ENV === 'development',
  
  // Authentication
  AUTH: {
    TOKEN_KEY: 'access_token',
    REFRESH_TOKEN_KEY: 'refresh_token',
    HEADER_PREFIX: 'Bearer',
  },
  
  // Centralized endpoints
  ENDPOINTS: API_ENDPOINTS,
  
  // Default credentials (development only)
  DEFAULT_CREDENTIALS: {
    username: 'HRUser',
    password: 'deloitte123',
  },
} as const;

// Add all service types you use in your app
export type ServiceType = 'job' | 'user' | 'auth' | 'validation' | 'resume' | 'interview' | 'agent';

// Service-specific base URL resolver
export function getServiceBaseUrl(service: ServiceType): string {
  const env = API_CONFIG.ENV;
  const isLocal = env === 'local';
  
  const serviceUrls = {
    job: isLocal ? 'http://110.183.1.90:8009/api' : 'https://0j71xq8ru3.execute-api.us-east-1.amazonaws.com/dev',
    user: isLocal ? 'http://110.183.1.90:8009/api' : 'https://0j71xq8ru3.execute-api.us-east-1.amazonaws.com/dev',
    auth: isLocal ? 'http://110.183.1.90:8009' : 'https://0j71xq8ru3.execute-api.us-east-1.amazonaws.com/dev',
    validation: isLocal ? 'http://110.183.1.90:8010' : 'https://0j71xq8ru3.execute-api.us-east-1.amazonaws.com/dev/api',
    resume: isLocal ? 'http://110.183.1.90:8009/api' : 'https://0j71xq8ru3.execute-api.us-east-1.amazonaws.com/dev',
  };
  
  return serviceUrls[service];
}

// Build full API URLs
export function getServiceApiUrl(service: ServiceType, endpoint: string): string {
  return `${getServiceBaseUrl(service)}${endpoint}`;
}

// Legacy support
export const getApiUrl = (endpoint: string): string => getServiceApiUrl('resume', endpoint);

// Development logging
export const logApiCall = (method: string, url: string, data?: any) => {
  if (API_CONFIG.DEBUG) {
    console.log(`[API] ${method} ${url}`, data || '');
  }
};

// Legacy support
export const API_BASE_URL = API_CONFIG.BASE_URL;